import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { blue, white } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const avatarTokens = [
  { propertyPath: 'backgroundColor', tokenName: '--semantic-bg-interactive-highlight-default' },
  { propertyPath: 'textColor', tokenName: '--semantic-text-inverse' },
] satisfies Token[];

export const avatarTokenMetadata: PaletteTokenMetadata = {
  componentName: 'avatar',
  tokens: avatarTokens,
};

export const avatar = (mode: PaletteMode, opts: GetThemeOptions): NonNullable<PaletteOptions['avatar']> => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return buildPaletteFromMetadata(avatarTokens, tokens);
  }

  // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
  return {
    backgroundColor: blue[500],
    textColor: white,
  };
};
